import React, { useState, useRef } from "react"
import { graphql, useStaticQuery  } from 'gatsby'
import * as styles from './ExpertCapabilities.module.scss'
import CapabilitiesList from './../../../../data/expertCapabilities.json'
import ExportCategory from "./ExpertSection/ExpertCategory"
import ControlArrows from "./ControlArrows/ControlArrows"


const ExpertCapabilities = ({serviceName, ServiceIcon, hexSize='med'}) => {
    const [ showCategory, setShowCategory ] = useState(0)
    
    const { allFile  } = useStaticQuery(graphql`
        query {
            allFile(filter: {
                extension: {regex: "/(webp)|(jpg)|(jpeg)|(svg)|(png)/"}, 
                sourceInstanceName: {eq: "expertCapabilities"}}) 
            {
                edges {
                    node {
                        name
                        publicURL
                        }
                    }
        }}`);
    const graphics = allFile.edges
    const serviceData = CapabilitiesList.filter(obj => {
            return obj.name === serviceName
        })
    
    const expertCategories = serviceData[0].capabilities.map((category, idx) => {
        return <ExportCategory key={idx} data={category} classes={`category${idx} ${showCategory === idx ? 'show' : ''}`} />
    })

    const numberCategories = useRef({
        val: expertCategories.length-1
    })

    const categoryImages = serviceData[0].capabilities.map((category, idx) => {
        let imageURL = graphics.filter(obj => {
            return obj.node.name === category.image
        })

        return <img loading='lazy' key={idx} style={{objectPosition: category.imagePosition ? category.imagePosition : 'center center'}} className={`category${idx} ${showCategory === idx ? 'show' : ''} ${styles.expertCapabilities_image}`} src={imageURL[0].node.publicURL} title={category.imageTitle} alt={category.imageTitle} />
    })

    const changeDisplayForward = () =>{
        setShowCategory(prevState => {
            if(prevState >= numberCategories.current.val ){
                return 0
            }
            return prevState+1
        })
    }
    const changeDisplayBack = () =>{
        setShowCategory(prevState => {
            if(prevState === 0 ){
                return numberCategories.current.val
            }
            return prevState-1
        })
    }

    return(  
            <article className={`${styles.expertCapabilities} inlineChildren_tabletSM` }>
               <section className={`${styles.expertCapabilities_imageWrap} ${styles[`${hexSize}HexBG`]}`}>
                   <div>
                    {categoryImages}
                   </div>
               </section>
               <section className={`${styles.expertCapabilities_contentWrap}`}>
                   <section className={styles.expertCapabilities_topBar}>
                       <div>
                            <ServiceIcon className={styles.expertCapabilities_serviceIcon} />
                            <em>Expert Capabilities</em>
                        </div>
                        {numberCategories.current.val !== 0 ?
                            <ControlArrows forwardClickHandler={changeDisplayForward} backClickHandler={changeDisplayBack} />
                            : ''
                        }
                   </section>
                   <section className={styles.expertCapabilities_content}>
                       {}
                        {expertCategories}
                   </section>
               </section>
           </article>          
    )
}

export default ExpertCapabilities